module.exports = __webpack_public_path__ + "img/result-bg.6f261d3e.png";